module.exports = __webpack_public_path__ + "img/4-before.028c3c70.jpg";